module.exports = __webpack_public_path__ + "static/media/MikeM4.c7cb978f.png";